import React from 'react';
import QuickActions from './QuickActions';
import NotificationPanel from './NotificationPanel';
import EnforceaBlogPanel from './EnforceaBlogPanel';

export default function MainDashboard() {
  return (
    <div className="min-h-screen bg-paper text-text-pri font-sans selection:bg-brand/20 selection:text-text-pri relative overflow-x-hidden">
      {/* Subtle architectural top radial spotlight */}
      <div
        className="pointer-events-none absolute inset-x-0 top-0 h-[340px] opacity-80"
        style={{
          background:
            'radial-gradient(ellipse 75% 55% at 50% -15%, rgba(37, 99, 235, 0.07), transparent 70%)',
        }}
      />

      <section className="relative py-6 sm:py-8 px-5 sm:px-8 lg:px-10 z-10">
        <div className="max-w-[1260px] mx-auto">
          <div className="grid grid-cols-1 xl:grid-cols-12 gap-6 items-start">
            {/* Left Column — Command Composer + Bento Workflow Grid */}
            <div className="xl:col-span-8">
              <QuickActions />
            </div>

            {/* Right Column — Live Tax Regulation & EnforceA Feed */}
            <div className="xl:col-span-4 space-y-5 xl:sticky xl:top-6">
              <NotificationPanel />
              <EnforceaBlogPanel />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
